import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";

import { ReactComponent as IcoCon } from '../images/sign-out-alt.svg';
import { ReactComponent as IcoGraf } from '../images/chart-line.svg';

const BoardAdmin = (user) => {
    const [content, setContent] = useState("");

    useEffect(() => {
        UserService.getAdminBoard_all().then(
            (response) => {

                let cont = []

                let actUsername = ''
                if (user.user !== undefined) { actUsername = user.user.username }

                for (let i = 0; i < response.data.length; i++) {

                    let dbid = response.data[i].id

                    // if (actUsername !== 'petr' || (actUsername === 'petr' && response.data[i].typ === '1')) {
                    cont.push(
                        <div className="radek">
                            <div className="f8">{response.data[i].site} </div>
                            <div className="f1"></div>

                            <div style={{ flex: '12', display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                                <div className="f4">{response.data[i].id}</div>
                                <div className="f4">{response.data[i].ipv}</div>
                                <div className="f4">{response.data[i].ipe}</div>
                            </div>
                            <div className="f1"></div>
                            <div className="f5">{response.data[i].time}</div>
                            <div className="f1">{response.data[i].type}</div>

                            <div className="f1">
                                <div className="btncon" >
                                    <Link to={{ pathname: '/charts', dbid }}>
                                        <IcoGraf className="icocon" />
                                    </Link>
                                </div>
                            </div>

                            <div className="f1">
                                <div className="btncon" >
                                    <Link to={{ pathname: '/device_content', device: { dbid } }}>
                                        <IcoCon className="icocon" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )
                    // }
                }

                setContent(cont);

            },
            (error) => {
                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                setContent(_content);

                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            }
        );
    }, []);

    return (
        <div className="container-fluid">
            <header className="jumbotron">
                {content}
            </header>
        </div>
    );
};

export default BoardAdmin;
